import { loadStripe, type Stripe } from '@stripe/stripe-js';

const KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '';

let cached: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  // E2E escape hatch: tests inject `window.__E2E_STRIPE__` to skip loadStripe().
  const e2e = (globalThis as { __E2E_STRIPE__?: Stripe }).__E2E_STRIPE__;
  if (e2e) return Promise.resolve(e2e);
  if (!cached) cached = loadStripe(KEY);
  return cached;
}
